<template>
  <div class="admin_bracket_elimination">
    <div class="actions">
      <inputerSelect
        v-if="!publishedPhase"
        :paths="['brackets', bracket.id, 'type']"
        :items="{ Elimination: 'Pavouk', DoubleElimination: 'Pavouk na 2 prohry'}" />
      <button v-if="!publishedPhase" class="generate" @click="generate">Vygenerovat ze skupin</button>
      <button class="export" @click="exportPdf">Export</button>
      <inputerSelect
        class="field"
        :item_null="true"
        empty="Hřiště: Vybrat"
        :paths="['brackets', bracket.id, 'fieldId']"
        :items="fields" />
      <button class="publish" @click="publish()">
        {{ publishedPhase? "Zrušit zveřejnění": "Zveřejnit" }}
      </button>
      <span class="count">Celkem zápasů: {{ categoryMatchesCount }}</span>
    </div>
    <div v-html="bracketSvg">
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { _ } from "../../../extend";
import inputerSelect from "../../../components/inputer-select";

export default {
  name: "bracket_elimination",
  components: {
    inputerSelect,
  },
  props: {
    bracket: {},
  },
  computed: {
    publishedPhase() {
      return this.bracket.published || false;
    },
    bracketMatches() {
      return _.filter(this.$store.state.matches, m => m.bracketId == this.bracket.id);
    },
    categoryMatchesCount() {
      return _.count(this.bracketMatches);
    },
    bracketSvg() {
      var svg = this.$store.state.bracketGraphSvgs[this.bracket.id];
      if (svg != null) {
        var getTeamText = bt => {
          if (bt.teamId != null)
            return Vue.filter('team_name_short')(bt.teamId);

          if (bt.resultType == "Looser" && bt.resultOfId != null) {
            var teamIndex = this.$store.state.matches[bt.resultOfId].index;
            return `Prohra z ${teamIndex + 1}`;
          }

          if (bt.advancingOrder != null)
            return `${bt.advancingOrder + 1}. tým`;

          return "";
        }
        _.forEach(this.$store.state.bracketTeams, (bt, id) => svg = svg.replaceAll(`~~${id}~~`, getTeamText(bt)));
      }

      return svg;
    },
    fields() {
      return _.select(this.$store.state.fields, f => `Hřiště: ${f.name}`);
    }
  },
  methods: {
    publish() {
      if (!this.publishedPhase && !confirm("Opravdu chcete pavouky pro všechny věkové kategorie zveřejnit? Zároveň se uloží všechny změny."))
        return;

      this.$store.commit("update", {
        paths: ["brackets", this.bracket.id, "published"],
        value: !this.publishedPhase,
      });
      this.$store.dispatch('save');
    },
    generate() {
      this.$store.dispatch('generateEliminationMatches', { bracket: this.bracket });
    },
    exportPdf() {
      this.$store.dispatch('exportTournamentPdf', { bracketId: this.bracket.id });
    },
  },
}
</script>

<style lang="sass">
@import "../../../sass/_components.sass"

.admin_bracket_elimination
  .generate
    @include button-secondary()
  .export
    @include button-secondary()
  .publish
    @include button-warning()

  .actions 
    .count
      @include button-secondary()
      cursor: inherit
    & > *
      &:not(:first-child):last-child
        @include last-input()
      &:not(:last-child):first-child
        @include first-input()
      &:not(:first-child):not(:last-child)
        @include middle-input()
  svg
    .teamUnderline
      stroke-width: 4px
      stroke: black
      stroke-opacity: 1
      fill: none
    .matchLine
      stroke-width: 2
      stroke: black
      stroke-opacity: 1
      fill: none
    .matchIndex
      font-size: 15px
      font-weight: bold
</style>
